export default class churchMapJwtServices {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  // church-map
  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.churchMapEndpoint, {
      params
    })
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.churchMapEndpoint}`, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.churchMapEndpoint}/${id}`, payload)
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.churchMapEndpoint}/${id}`)
  }

  fetchAssemblyTypes() {
    return this.axiosIns.get(`${this.jwtConfig.main.churchMapEndpoint}/assembly-types`)
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.churchMapEndpoint}/export`, {
      params,
      responseType: "blob"
    })
  }

  import(formData) {
    return this.axiosIns.post(`${this.jwtConfig.main.churchMapEndpoint}/import`, formData)
  }
}
